import List from 'src/storage/treatmentsList';

class PatientAppointmentsModel extends List {
  id = 'PatientAppointmentsModel';
  defaultState = () => ({
    current: 'recent',
    statusGroup: 'all'
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = {
    key: 'date',
    desc: true
  };
  apiConfig = {
    refresh: {
      url: 'appointment/refresh',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'appointment_list'
    },
    list: {
      url: 'appointment/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'appointment_list'
    },
    search: {
      url: 'appointment/search',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'appointment_list'
    }
  };

  _events = {
    profile: 'handleProfile',
    openPatient: 'onOpenPatient',
    'foxsocket:message:msg': 'onMessage',
    'foxsocket:message:msg_update': 'onMessageUpdateWS'
  };

  filterItem = (data) => data.msgType === 'appointment';

  listParams(loadMore) {
    let req = {
      skip: 0,
      patientId: this.state.patient?.id,
      limit: this.listLimit,
      statusGroup: this.state.statusGroup === 'all' ? [] : [this.state.statusGroup],
      doctorIds: this.state.user?.doctorIds || []
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }

    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }

    return req;
  }

  handleProfile = ({ password, ...profile }) => {
    void password;
    this.setState({ user: profile });
  };

  onOpenPatient = (patient = null) => {
    this.setState({
      patient
    });
    this.refresh();
  };
}
const appointmentsModel = new PatientAppointmentsModel();

export default appointmentsModel;
